import React from "react";
import { InputFactory } from "nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import { exportCSVUseCase } from "../../usecases/csv/usecases";

import withRouter from "../../withRouter";
import BaseListPage from "../../base/BaseListPage";

import DashboardAppPagePresenter from "./DashboardAppPagePresenter";
import NavBar from "../../components/NavbarCustom";
import Charts from "../../components/BarPieChart";

class DashboardAppPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DashboardAppPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      totalCount: 0,
      objects: [],
      countJob: 0,
    };
  }

  componentDidMount() {
    this.presenter.findObjects();
    this.presenter.findJobs();
  }

  getCollectionName() {
    return "dashboard";
  }

  render() {
    const { totalCount, countJob } = this.state;

    return (
      <>
        <NavBar />
        <div className="p-3 col-lg-12">
          <h5 className="fw-bold mt-3 text-capitalize">Dashboard Overview</h5>
          <div className="d-flex flex-row align-items-center gap-3 mt-3">
            <div style={{ width: "247px" }}>
              <span>Client</span>
              <InputFactory
                type="Enum"
                options={["Yes", "No"]}
                placeholder="Select Client"
              />
            </div>
            <div style={{ width: "246px" }}>
              <span>Position</span>
              <InputFactory
                type="Enum"
                options={["Yes", "No"]}
                placeholder="Select Position"
              />
            </div>
            <div>
              <span>Date Range</span>
              <InputFactory
                type="Date"
                options={["Yes", "No"]}
                placeholder="mm/dd/yy"
              />
            </div>

            <div className="d-flex align-items-center mt-4">
              <i className="bi bi-arrow-right"></i>
            </div>

            <div>
              <span>&nbsp;</span>
              <InputFactory
                type="Date"
                options={["Yes", "No"]}
                placeholder="mm/dd/yy"
              />
            </div>
          </div>
          <div className="d-flex flex-row gap-3 mt-4 w-100">
            <div
              className="card shadow-sm rounded-4"
              style={{ width: "246px" }}
            >
              <div className="card-body">
                <div className="mb-3">
                  <i
                    className="bi bi-briefcase fs-2"
                    style={{ color: "blue" }}
                  ></i>{" "}
                  {/* Example icon */}
                </div>
                <h5 className="card-title">Total Opening</h5>
                <p className="card-text fw-bold fs-3">{countJob}</p>
              </div>
            </div>

            <div
              className="card shadow-sm rounded-4"
              style={{ width: "246px" }}
            >
              <div className="card-body">
                <div className="mb-3">
                  <i
                    className="bi bi-graph-up fs-2"
                    style={{ color: "green" }}
                  ></i>{" "}
                  {/* Example icon */}
                </div>
                <h5 className="card-title">Hiring Rate</h5>
                <p className="card-text fw-bold fs-3">80%</p>
              </div>
            </div>

            <div
              className="card shadow-sm rounded-4"
              style={{ width: "246px" }}
            >
              <div className="card-body">
                <div className="mb-3">
                  <i
                    className="bi bi-people fs-2"
                    style={{ color: "blue" }}
                  ></i>{" "}
                  {/* Example icon */}
                </div>
                <h5 className="card-title">Total Applicants</h5>
                <p className="card-text fw-bold fs-3">{totalCount}</p>
              </div>
            </div>
          </div>
          <Charts />
        </div>
      </>
    );
  }
}

export default withRouter(DashboardAppPage);
